import styled from 'styled-components';

export const ToastNotificationsWrapper = styled.div`
  position: absolute;
  bottom: 10px;
  ${({isDesktop}) => (isDesktop ? 'width: 350px;' : 'width: 100%;')};
`;
